<template>
  <component
    :is="el"
    v-touch:start="onTouchStart"
    v-touch:moving="onTouchMove"
    v-touch:end="answerQuestionByDrag"
    class="dragger-area"
  >
    <slot :direction-percentage="directionPercentage" />
  </component>
</template>

<script>
const DRAG_VIEW_PERCENTAGE_ACTIVATION = 0.25;
const DRAG_VIEW_PIXEL_AREA = 300;

const getDefaultDirectionPercentage = () => ({
  x: 0,
  y: 0,
});

export default {
  name: 'DraggerArea',

  props: {
    el: {
      type: String,
      default: 'div',
    },
    currentQuestionIndex: {
      type: Number,
      default: undefined,
    },
  },

  data() {
    return {
      startPos: {
        x: 0,
        y: 0,
      },
      directionPercentage: getDefaultDirectionPercentage(),
    };
  },

  watch: {
    currentQuestionIndex: {
      immediate: true,
      handler(currentQuestion, lastQuestion) {
        if (currentQuestion && currentQuestion !== lastQuestion) {
          // reset
          this.directionPercentage = getDefaultDirectionPercentage();
        }
      },
    },
  },

  methods: {
    onTouchStart({ touches }) {
      if (!touches) return;

      this.startPos.x = touches[0].clientX;
      this.startPos.y = touches[0].clientY;
    },

    onTouchMove({ touches }) {
      if (!touches) return;

      const differenceX = this.startPos.x - touches[0].clientX;
      const differenceY = this.startPos.y - touches[0].clientY;

      this.directionPercentage.x = -differenceX / DRAG_VIEW_PIXEL_AREA;
      this.directionPercentage.y = differenceY / DRAG_VIEW_PIXEL_AREA;
    },

    answerQuestionByDrag() {
      const directionLevel = Math.abs(this.directionPercentage.x / DRAG_VIEW_PERCENTAGE_ACTIVATION);

      if (directionLevel < 1) {
        this.directionPercentage.x = 0;
        return;
      }

      this.$emit('question-answered', directionLevel < 1 ? 0 : 1);
    },
  },
};
</script>
